import { boolean, defineAction, number, object, string } from '~/prix'
import agentGeolocationAction from './agentGeolocation.action.json'

const agentGeolocationDefinition = defineAction({
  ...agentGeolocationAction,
  input: object({
    agentCpf: string(),
    latitude: number(),
    longitude: number(),
    accuracy: number().isOptional(),
  }),
  output: object({
    status: string(),
  }),
})

export default agentGeolocationDefinition
